module.exports = __webpack_public_path__ + "img/msg-bg.003aac35.png";